import moment from 'moment'
import axios from 'axios'

// 导出
export const userCentered = {
  data() {
    return {
      // 翻页
      page: {
        pageNo: 1,
        pageSize: 20
      },
      source: null, // 取消请求
      timer: null, // 延迟请求定时器
      menuTimer: null, // 菜单定时器
      // 安卓机自定菜单
      customMenu: {
        x: 0,
        y: 0,
        show: false,
        orderFlg: 0,
        paymentFlag: 0,
        goodsTypeId: 0,
        orderId: 0
      }
    }
  },
  computed: {
    /**
     * todo 商品状态
     */
    getOrderType() {
      return (type, goodsTypeId, paymentFlag) => {
        let res = ''
        // 零售
        if (goodsTypeId === 4) {
          switch (type) {
            case 0:
              res = '已订阅'
              break
            case 3:
              res = '已删除'
              break
            case 6:
              res = '待付款'
              break
            case 4:
              res = '待发货'
              break
            case 5:
              res = '已发货'
              break
            case 7:
              res = '已超时'
              break
            case 10:
              res = '已取消'
              break
            default:
              res = ''
              break
          }
        } else {
          // 非零售
          // 报卡
          if (goodsTypeId === 1) {
            switch (type) {
              case 1:
                res = '已确认'
                break
            }
          } else {
            // 非报卡
            switch (type) {
              case 0:
                res = '待确认'
                break
              case 1:
                res = paymentFlag ? '已确认' : '待付款'
                break
            }
          }
        }
        return res
      }
    }
  },
  watch: {
    /**
     * todo 监听切换状态
     */
    active(newValue, oldValue) {
      this.list = []
      window.sessionStorage.setItem('active', newValue)
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.onRefresh()
      }, 500)
    }
  },
  methods: {
    moment,
    /**
     * todo 长按弹出自定义菜单
     */
    openMenu(e, type, item) {
      if (!/android/gi.test(window.navigator.userAgent)) {
        return
      }
      let { orderFlg, paymentFlag, goodsTypeId, orderId } = item
      let [x, y] = [document.documentElement.clientWidth, document.documentElement.clientHeight]
      switch (type) {
        case 'start':
          this.isPulling = false
          this.customMenu = {
            ...this.customMenu,
            show: false
          }
          if (this.menuTimer) {
            clearTimeout(this.menuTimer)
            this.menuTimer = null
          }

          // 菜单定位默认值，远离可视范围
          this.customMenu = {
            x,
            y,
            show: true,
            orderFlg,
            paymentFlag,
            goodsTypeId,
            orderId
          }
          this.menuTimer = setTimeout(() => {
            this.isPulling = true
            this.$nextTick(() => {
              const clientX = e.touches[0].clientX
              const clientY = e.touches[0].clientY
              const offsetWidth = this.$refs.menu.offsetWidth
              const offsetHeight = this.$refs.menu.offsetHeight
              const clientWidth = document.documentElement.clientWidth
              const clientHeight = document.documentElement.clientHeight
              // x坐标大于可视宽度
              if (clientX + offsetWidth >= clientWidth - 10) {
                x = clientX - (clientX + offsetWidth - clientWidth + 50)
                y = clientY + 10
                // 且y坐标大于可视距离
                if (clientY + offsetHeight >= clientHeight - offsetHeight - 50) {
                  y = clientHeight - offsetHeight - 80
                }
                // y坐标大于可视高度
              } else if (clientY + offsetHeight >= clientHeight - offsetHeight - 50) {
                x = clientX + 10
                y = clientHeight - offsetHeight - 80
                // 正常显示下的坐标
              } else {
                x = clientX + 10
                y = clientY
              }
              this.customMenu = {
                ...this.customMenu,
                x,
                y
              }
            })
          }, 800)

          break
        case 'move':
          if (this.isPulling) {
            return
          }
          this.customMenu = {
            ...this.customMenu,
            show: false
          }
          clearTimeout(this.menuTimer)
          this.menuTimer = null
          return

        default:
          break
      }
      return true
    },
    /**
     * todo 拉取预支付
     */
    payment(orderId) {
      this.orderId = orderId
      let params = {
        tno: orderId
      }
      this.$api.user.advancePayOrder(params).then((res) => {
        let { result } = res
        if (result && JSON.stringify(result) !== '{}') {
          this.weixinJSBridge(result.weixinPay)
        }
      })
    },
    /**
     * todo 拉取微信支付
     */
    weixinJSBridge(payInfo) {
      let _this = this
      try {
        let { appId, timeStamp, nonceStr, pay_package, paysign } = payInfo
        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest',
          {
            appId, //公众号名称，由商户传入
            timeStamp: timeStamp + '', //时间戳
            nonceStr, //随机串
            package: pay_package, ////扩展包
            signType: 'MD5', //微信签名方式:1.sha1
            paySign: paysign
          },
          (res) => {
            // 支付成功
            if (res.err_msg == 'get_brand_wcpay_request:ok') {
              _this.validatorPayResult()
            } else {
              _this.$toast('支付失败！')
            }
          }
        )
      } catch (error) {
        alert(error)
      }
    },
    /**
     * todo 支付完成后拉取支付确认接口
     */
    validatorPayResult() {
      let params = {
        tno: this.orderId
      }
      this.$api.user.validatorPayResult(params).then((res) => {
        let { status, message } = res
        if (status) {
          if (!this.active) {
            window.location.reload()
          } else {
            this.active = 0
          }
        } else {
          this.$toast(message)
        }
      })
    },
    /**
     * todo 查看详情
     */
    browseDetail(orderId) {
      this.$router.replace({ name: 'OrderDetail', query: { orderId } })
    },
    /**
     * todo 超时订单移出
     *  @param {orderId: 订单id}
     */
    overTimeOrderDelete(orderId) {
      let params = {
        orderId
      }

      // let filters = []
      // this.list.forEach((item) => {
      //   if (item.orderId === orderId) {
      //     item.animation = true
      //   } else {
      //     filters.push(item)
      //   }
      // })
      // setTimeout(() => {
      //   this.list = filters
      // }, 400)

      this.$api.userCentered.overTimeOrderDelete(params).then((res) => {
        let { status, message } = res
        if (status) {
          // this.onRefresh()
          let filters = []
          this.list.forEach((item) => {
            if (item.orderId === orderId) {
              item.animation = true
            } else {
              filters.push(item)
            }
          })
          setTimeout(() => {
            this.list = filters
          }, 400)
        } else {
          this.$toast(message)
        }
      })
    },
    /**
     *  todo 取消支付订单
     * @param {orderId: 订单id}
     */
    cancelPayOrder(orderId) {
      let params = {
        orderId
      }
      this.$api.userCentered.cancelPayOrder(params).then((res) => {
        let { status, message } = res
        if (status) {
          this.onRefresh()
        } else {
          this.$toast(message)
        }
      })
    },
    /**
     * todo 循环设置倒计时
     */
    getDownCount(item) {
      let timer1 = null
      let timer2 = null
      let _this = this
      // let downCountTime = item.downCount
      timer1 = setTimeout(function cb() {
        let nowTime = moment().valueOf()
        let current = nowTime - moment(item.lastupTime).valueOf()
        let downCountTime = 15 * 60 * 1000 - current
        item.downCountString = moment(downCountTime).format('mm:ss')
        if (downCountTime <= 0) {
          clearTimeout(timer1)
          clearTimeout(timer2)
          item.orderFlg = 7
          _this.$forceUpdate()
          return
        }
        downCountTime = downCountTime - 1000
        timer2 = setTimeout(cb, 1000)
      }, 1000)
    },
    /**
     * todo 获取订单列表
     */
    getOrderList() {
      let params = {
        orderFlag: this.active,
        ...this.page
      }

      if (this.source) {
        this.source.cancel('取消查询！')
      }
      let cancelToken = axios.CancelToken
      this.source = cancelToken.source()

      return new Promise((resolve, reject) => {
        this.$api.userCentered.getOrderList(params, { cancelToken: this.source.token }).then((res) => {
          let { result } = res
          if (Array.isArray(result) && result.length) {
            this.list = this.list.concat(result).map((item) => {
              if (item.goodsTypeId === 4 && item.orderFlg === 6) {
                let nowTime = moment().valueOf()
                let current = nowTime - moment(item.lastupTime).valueOf()
                let downCountTime = 15 * 60 * 1000 - current
                return { ...item, downCount: downCountTime, downCountString: moment(downCountTime).format('mm:ss'), animation: false }
              } else {
                return { ...item, animation: false }
              }
            })
            // 循环设置倒计时
            this.list.forEach((item) => {
              if (item.downCount) {
                this.getDownCount(item)
              }
            })
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.refreshing = false
        }
        this.getOrderList(this.activeName)
          .then((res) => {
            this.loading = false
            this.page = {
              ...this.page,
              pageNo: this.page.pageNo + 1
            }
          })
          .catch(() => {
            this.finished = true
            this.loading = false
          })
      }, 1000)
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false
      this.list = []

      // 重新加载数据
      this.page = {
        ...this.page,
        pageNo: 1
      }
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    }
  }
}
